import { UpperCasePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { capitalize, get, result } from 'lodash';
import * as moment from 'moment';
import { exportToCsv } from 'src/app/utils/common.utils';

@Injectable({
  providedIn: 'root'
})
export class CsvService {
  upperCase = new UpperCasePipe();

  constructor() { }

  generateTripItineraryReport(trips:any, date:any, timezone:any,preLevelOfService:any, preSpacetypes:any, preServiceAreas:any,preFundingSource:any) {
    const table = [
      [
        "Trip ID",
        "Trip Status",
        "Created At",
        "Service Area",
        "Pick-up Address",
        "Pick-up Date",
        "Drop-Off Address",
        "Drop-Off Date",
        "Actual Miles",
        "Funding Source",
        "LOS",
        "Space Type",
        "Passenger Name",
        "Contact Number",
        "Phone Number",
        "Driver Name",
        "Dispatcher Notes",
        "Payment Status",

        "FS Pre Special Fare",
        "FS Total Fare",
        "FS Cancel Charges",
        "FS No Show Charges",
        "Company Special Fare",
        "Company Total Fare",
        "Company Cancel Charges",
        "Company No Show Charges",
      ]];
    trips.forEach((trip:any) => {
      let acceptedDate, pickupDate, arrivedDate, endDate, finishDate, scheduleTime, appointmentTime, createdAt = ' ';
      if (trip.scheduleTime) {
        scheduleTime = moment(trip.scheduleTime).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.createdAt) {
        createdAt = moment(trip.createdAt).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.appointmentTime) {
        appointmentTime = moment(trip.appointmentTime).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.job) {
        if (trip.job.trackInfoJob) {
          if (trip.job.trackInfoJob.jobAccepted) {
            if (trip.job.trackInfoJob.jobAccepted.time) {
              acceptedDate = moment(trip.job.trackInfoJob.jobAccepted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobArrived) {
            if (trip.job.trackInfoJob.jobArrived.time) {
              pickupDate = moment(trip.job.trackInfoJob.jobArrived.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobStarted) {
            if (trip.job.trackInfoJob.jobStarted.time) {
              arrivedDate = moment(trip.job.trackInfoJob.jobStarted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobCompleted) {
            if (trip.job.trackInfoJob.jobCompleted.time) {
              endDate = moment(trip.job.trackInfoJob.jobCompleted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }

          if (trip.job.trackInfoJob.jobFinished) {
            if (trip.job.trackInfoJob.jobFinished.time) {
              finishDate = moment(trip.job.trackInfoJob.jobFinished.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }

        }

      }

      function capitalize(str:any) {
        return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : ' ';
      }

      const fare = trip.fare || {};
      const offeredFare = trip.offeredFare || {};

      let paymentStatus = '';
      if (trip.flags?.isFullPaid) paymentStatus = 'Paid';
      else if (trip.flags?.isPartiallyPaid) paymentStatus = 'Partially Paid';

      let data = [
        trip.reference && trip.suffix ? trip.reference + '-' +  trip.suffix : ' ',
        capitalize(trip.status),
        createdAt ? createdAt : ' ',
        preServiceAreas[trip.serviceArea] ? preServiceAreas[trip.serviceArea].title : ' ',
        trip.pickup.address ? trip.pickup.address.name : ' ',
        trip.pickup ? moment(trip.pickup.time).tz(timezone).format("MM/DD/YYYY HH:mm") : ' ',
        trip.destination.address ? trip.destination.address.name : ' ',
        trip.destination ? moment(trip.destination.time).tz(timezone).format("MM/DD/YYYY HH:mm") : ' ',
        trip.miles ? trip.miles : '0',
        preFundingSource[trip.fundingsource] ? preFundingSource[trip.fundingsource].title : ' ',
        preLevelOfService[trip.levelOfService] ? (this.upperCase.transform(preLevelOfService[trip.levelOfService].title)) : ' ',
        preSpacetypes[trip.spaceType] ?(this.upperCase.transform(preSpacetypes[trip.spaceType].title)) : ' ',
        trip ? trip.member?.displayName : ' ',
        trip.member && trip.member.contactNumber ? `\t${trip.member.contactNumber}` : 'N/A',
        trip.pickup && trip.pickup.phoneNumber ? `\t${trip.pickup.phoneNumber}` : 'N/A',
        trip.driver ? trip.driver.displayName : ' ',
        trip.generalNotes ? trip.generalNotes : ' ',
        paymentStatus,

        trip.preSpecialRate ? Number(trip.preSpecialRate).toFixed(2) : '',
        this.extractTotalFare(fare).toFixed(2),
        this.extractFareAmount(fare.cancelBreakdown?.cancelCharges).toFixed(2),
        this.extractFareAmount(fare.cancelBreakdown?.noShowCharges).toFixed(2),
        trip.specialRate ? Number(trip.specialRate).toFixed(2) : '',
        this.extractTotalFare(offeredFare).toFixed(2),
        this.extractFareAmount(offeredFare.cancelBreakdown?.cancelCharges).toFixed(2),
        this.extractFareAmount(offeredFare.cancelBreakdown?.noShowCharges).toFixed(2),
      ]
      table.push(data)
    });

    exportToCsv(`reports-${moment(date[0]).tz(timezone).format("MM-DD-YYYY")}-${moment(date[1]).tz(timezone).format("MM-DD-YYYY")}.csv`, table);
  }

  generatePrivatePayReport(result: any, dateRange:any) {
    const table = [
      [
        "Funding Source",
        "Company",
        "Driver",
        "Status",
        "Reference ID",
        "Member",
        "Service Date",
        "Miles",
        "Space Type",
        "LOS",
        "Pre Special Fare",
        "Special Rate",
        "Flat FS",
        "Flat Company",
        "Actual FS",
        "Actual Company",
        "Flat Commission",
        "Actual Commission",
      ]];
    result[0].data.forEach((trip: any) => {
      let data = [
        trip.fundingsource ? trip.fundingsource.title : ' ',
        trip.company ? trip.company.name : ' ',
        trip?.driver ? trip?.driver?.displayName : ' ',
        trip.status + this.gettingCancelledBadge(trip),
        trip.reference +'-'+ trip.suffix || ' ',
        trip?.member?.displayName,
        trip.pickup ? moment(trip.pickup.time).format("MM/DD/YYYY HH:mm") : ' ',
        trip.miles ? trip.miles : '0',
        trip.spaceType ? (this.upperCase.transform(trip.spaceType.title)) : ' ',
        trip.levelOfService ? (this.upperCase.transform(trip.levelOfService.title)) : ' ',

        (trip.preSpecialTotal != null ? Number(trip.preSpecialTotal).toFixed(2) : '0.00'),
        (trip.specialTotal != null ? Number(trip.specialTotal).toFixed(2) : '0.00'),
        (trip.flatFSTotal != null ? Number(trip.flatFSTotal).toFixed(2) : '0.00'),
        (trip.flatCompanyTotal != null ? Number(trip.flatCompanyTotal).toFixed(2) : '0.00'),
        (trip.actualFSTotal != null ? Number(trip.actualFSTotal).toFixed(2) : '0.00'),
        (trip.actualCompanyTotal != null ? Number(trip.actualCompanyTotal).toFixed(2) : '0.00'),
        (trip.flatCommissionTotal != null ? Number(trip.flatCommissionTotal).toFixed(2) : '0.00'),
        (trip.actualCommissionTotal != null ? Number(trip.actualCommissionTotal).toFixed(2) : '0.00')
      ]
      table.push(data)
    });
    table.push([...new Array(11).fill(' ')]);
    table.push([...new Array(11).fill(' ')]);
    
    table.push([...new Array(9).fill(' '), 'Trips', 'Total Pre Special', 'Total Special', 'Total Flat FS', 'Total Flat Company', 'Total Actual FS', 'Total Actual Company', 'Total Flat Commission', 'Total Actual Commission']);
    table.push([...new Array(9).fill(' '),
      result[0].overview.totalTrips || 0,
      (result[0].overview.preSpecialTotal != null ? Number(result[0].overview.preSpecialTotal).toFixed(2) : '0.00'),
      (result[0].overview.specialTotal != null ? Number(result[0].overview.specialTotal).toFixed(2) : '0.00'),
      (result[0].overview.flatFSTotal != null ? Number(result[0].overview.flatFSTotal).toFixed(2) : '0.00'),
      (result[0].overview.flatCompanyTotal != null ? Number(result[0].overview.flatCompanyTotal).toFixed(2) : '0.00'),
      (result[0].overview.actualFSTotal != null ? Number(result[0].overview.actualFSTotal).toFixed(2) : '0.00'),
      (result[0].overview.actualCompanyTotal != null ? Number(result[0].overview.actualCompanyTotal).toFixed(2) : '0.00'),
      (result[0].overview.flatCommissionTotal != null ? Number(result[0].overview.flatCommissionTotal).toFixed(2) : '0.00'),
      (result[0].overview.actualCommissionTotal != null ? Number(result[0].overview.actualCommissionTotal).toFixed(2) : '0.00'),
    ]);
    
    exportToCsv(`report-${moment(dateRange[0]).format("MM-DD-YYYY")}-${moment(dateRange[1]).format("MM-DD-YYYY")}.csv`, table);
  }
  generatePrivateCompanyPayReport(result: any, dateRange:any ) {
    const rawData = result?.[0]?.data || [];
    const companyTrips = rawData.filter((trip: any) => trip?.company && (trip.company.name || trip.company._id));

    const table = [
      [
        // "Funding Source",
        "Company",
        "Driver",
        "Status",
        "Reference ID",
        "Member",
        "Service Date",
        "Miles",
        "Space Type",
        "LOS",
        "Special Rate",
        "Flat Company",
        "Actual Company",
        
      ]];

    let totalSpecial = 0;
    let totalFlatCompany = 0;
    let totalActualCompany = 0;

    companyTrips.forEach((trip: any) => {
      const special = Number(trip.specialTotal || 0);
      const flatCompany = Number(trip.flatCompanyTotal || 0);
      const actualCompany = Number(trip.actualCompanyTotal || 0);

      totalSpecial += special;
      totalFlatCompany += flatCompany;
      totalActualCompany += actualCompany;

      let data = [
        trip.company ? trip.company.name : ' ',
        trip?.driver ? trip?.driver?.displayName : ' ',
        trip.status + this.gettingCancelledBadge(trip),
        trip.reference +'-'+ trip.suffix || ' ',
        trip?.member?.displayName || ' ',
        trip.pickup ? moment(trip.pickup.time).format("MM/DD/YYYY HH:mm") : ' ',
        trip.miles ? trip.miles : '0',
        trip.spaceType ? (this.upperCase.transform(trip.spaceType.title)) : ' ',
        trip.levelOfService ? (this.upperCase.transform(trip.levelOfService.title)) : ' ',

        special.toFixed(2),
        flatCompany.toFixed(2),
        actualCompany.toFixed(2),
  
      ];
      table.push(data);
    });
    table.push([...new Array(10).fill(' ')]);
    table.push([...new Array(10).fill(' ')]);
    
    table.push([...new Array(8).fill(' '), 'Trips', 'Total Special', 'Total Flat Company', 'Total Actual Company']);
    table.push([
      ...new Array(8).fill(' '),
      companyTrips.length,
      totalSpecial.toFixed(2),
      totalFlatCompany.toFixed(2),
      totalActualCompany.toFixed(2),
    ]);
    
    exportToCsv(`report-${moment(dateRange[0]).format("MM-DD-YYYY")}-${moment(dateRange[1]).format("MM-DD-YYYY")}-company.csv`, table);
  }

  generatePrivateFSPayReport(result: any, dateRange:any) {
    const rawData = result?.[0]?.data || [];
    const fsTrips = rawData.filter((trip: any) => trip?.fundingsource && (trip.fundingsource.title || trip.fundingsource._id));

    const table = [
      [
        "Funding Source",
        // "Company",
        "Driver",
        "Status",
        "Reference ID",
        "Member",
        "Service Date",
        "Miles",
        "Space Type",
        "LOS",
        "Pre Special Fare",
        // "Special Rate",
        "Flat FS",
        "Actual FS",
   
      ]];

    let totalPreSpecial = 0;
    let totalFlatFS = 0;
    let totalActualFS = 0;

    fsTrips.forEach((trip: any) => {
      const preSpecial = Number(trip.preSpecialTotal || 0);
      const flatFS = Number(trip.flatFSTotal || 0);
      const actualFS = Number(trip.actualFSTotal || 0);

      totalPreSpecial += preSpecial;
      totalFlatFS += flatFS;
      totalActualFS += actualFS;

      let data = [
        trip.fundingsource ? trip.fundingsource.title : ' ',
        trip?.driver ? trip?.driver?.displayName : ' ',
        trip.status + this.gettingCancelledBadge(trip),
        trip.reference +'-'+ trip.suffix || ' ',
        trip?.member?.displayName || ' ',
        trip.pickup ? moment(trip.pickup.time).format("MM/DD/YYYY HH:mm") : ' ',
        trip.miles ? trip.miles : '0',
        trip.spaceType ? (this.upperCase.transform(trip.spaceType.title)) : ' ',
        trip.levelOfService ? (this.upperCase.transform(trip.levelOfService.title)) : ' ',

        preSpecial.toFixed(2),
        flatFS.toFixed(2),
        actualFS.toFixed(2),

      ];
      table.push(data);
    });
    table.push([...new Array(9).fill(' ')]);
    table.push([...new Array(9).fill(' ')]);
    
    table.push([...new Array(8).fill(' '), 'Trips', 'Total Pre Special', 'Total Flat FS', 'Total Actual FS']);
    table.push([
      ...new Array(8).fill(' '),
      fsTrips.length,
      totalPreSpecial.toFixed(2),
      totalFlatFS.toFixed(2),
      totalActualFS.toFixed(2),
    ]);
    
    exportToCsv(`report-${moment(dateRange[0]).format("MM-DD-YYYY")}-${moment(dateRange[1]).format("MM-DD-YYYY")}-fs.csv`, table);
  }

  // Pulls a plain numeric value out of fare fields that are sometimes
  // stored as a raw number and sometimes as an object like { fare, from, to }.
  private extractFareAmount(value: any): number {
    if (value === null || value === undefined || value === '') return 0;
    if (typeof value === 'number') return value;
    if (typeof value === 'object') {
      const nested = value.fare ?? value.total ?? value.value;
      return typeof nested === 'number' ? nested : 0;
    }
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  }

  // The grand total, as shown in Trip Details, lives on fare.breakdown.total.
  // Fall back to fare.total for records where breakdown isn't populated.
  private extractTotalFare(fare: any): number {
    if (!fare) return 0;
    return this.extractFareAmount(fare.breakdown?.total ?? fare.total);
  }

  gettingCancelledBadge(trip: any) {
    let result = '';
    if (trip.status === 'cancelled' && trip.flags) {
      if (trip.flags.isBillable) {
        result += ' - Billable';
      }
      if (trip.flags.isNoShow) {
        result += ' - No Show';
      }
    }
    return result;
  }

  generateRawTripReport(trips: any, date: any, timezone: any, source: any) {
    const table = [
      [
        "trip_id",
        "trip_status",

        "passenger_name",
        "contact_number",
        "phone_number",
        "dob",
        "weight",

        "pu_address",
        "pu_date",

        "do_address",
        "do_date",
        "appointment_type",
        "trip_miles",

        "funding_source",

        "driver_name",

        "vehicle",

        "spacetype",

        // events
        "onway_time",
        "onway_coords",
        "arrived_time",
        "arrived_coords",
        "in_progress_time",
        "in_progress_coords",
        "completed_time",
        "completed_coords",

        // fare
        "total_fare",
        "offered_fare",

        "base_fare",
        "base_fare_code",
        "per_mile",
        "per_mile_code",

        "created_at",

        "driver_notes",
        "biller_notes",

        "service_area",
        "level_of_service",

        "wait_time",
        "trip_miles",
        "trip_time",
        "total_trip_miles",
        "total_trip_time",
        "Addon Fare",

        "FS Pre Special Fare",
        "FS Cancel Charges",
        "FS No Show Charges",
        "Company Special Fare",
        "Company Cancel Charges",
        "Company No Show Charges",
      ]
    ];

    trips.forEach((trip: any) => {
      // extract events
      const onway = trip.events?.find((e: any) => e.status === "onway");
      const arrived = trip.events?.find((e: any) => e.status === "arrived");
      const inProgress = trip.events?.find((e: any) => e.status === "in_progress");
      const completed = trip.events?.find((e: any) => e.status === "completed");

      // offered fare as “final”
      const fare = trip.fare || {};
      const offeredFare = trip.offeredFare || {};
      const finalFare =
        source === 'fsBilling'
          ? (
            trip.status === "cancelled"
              ? (trip?.flags?.isNoShow && trip?.fare?.cancelBreakdown?.noShowCharges
                ? trip?.fare?.cancelBreakdown?.noShowCharges
                : trip?.fare?.cancelBreakdown?.cancelCharges)
              : trip.status === "completed"
                ? trip?.fare?.breakdown?.total
                : ""
          )
          : (
            trip.status === "cancelled"
              ? (trip?.flags?.isNoShow && trip?.offeredFare?.cancelBreakdown?.noShowCharges
                ? trip?.offeredFare?.cancelBreakdown?.noShowCharges
                : trip?.offeredFare?.cancelBreakdown?.cancelCharges)
              : trip.status === "completed"
                ? trip?.offeredFare?.breakdown?.total
                : ""
          );
      const isCancelled = trip.status === "cancelled";
      const breakdown = source === 'fsBilling' ? trip?.fare?.breakdown: trip?.offeredFare?.breakdown;
      
      const data = [
        trip.reference +" "+ trip?.suffix  || "",
        trip.status || "",

        trip.member?.displayName ? trip.member?.displayName : "",
        trip.member?.contactNumber || "",
        trip.member?.phoneNumber || "",
        trip.member?.dateOfBirth
          ? moment(trip.member.dateOfBirth).format("MMM DD, YYYY")
          : "",
        trip.member?.weight || "",

        trip.pickup?.address?.name || "",
        trip.pickup?.time
          ? moment(trip.pickup.time).tz(timezone).format("MMM DD, YYYY : HH:mm")
          : "",

        trip.destination?.address?.name || "",
        trip.destination?.time
          ? moment(trip.destination.time).tz(timezone).format("MMM DD, YYYY : HH:mm")
          : "",
        trip.appointmentType?.title || "",
        trip.miles || "",

        trip.fundingsource?.title || "",

        trip.driver ? `${trip.driver.displayName}` : "",

        trip.vehicle
          ? `${trip.vehicle.make} - ${trip.vehicle.model} - ${trip.vehicle.vin}`
          : "",

        (this.upperCase.transform(trip.spaceType?.title)) || "",

        // events
        onway?.time
          ? moment(onway.time).tz(timezone).format("MMM DD, YYYY : HH:mm")
          : "",
        onway ? `${onway.latitude},${onway.longitude}` : "",

        arrived?.time
          ? moment(arrived.time).tz(timezone).format("MMM DD, YYYY : HH:mm")
          : "",
        arrived ? `${arrived.latitude},${arrived.longitude}` : "",

        inProgress?.time
          ? moment(inProgress.time).tz(timezone).format("MMM DD, YYYY : HH:mm")
          : "",
        inProgress ? `${inProgress.latitude},${inProgress.longitude}` : "",

        completed?.time
          ? moment(completed.time).tz(timezone).format("MMM DD, YYYY : HH:mm")
          : "",
        completed ? `${completed.latitude},${completed.longitude}` : "",

        // fare
        finalFare,
        offeredFare.breakdown?.total || "",
        isCancelled ? "" : breakdown?.baseFare || "",
        fare.baseFareCode || "",
        isCancelled ? "" : breakdown?.perMileFare || "",
        fare.perMileCode || "",


        trip.createdAt
          ? moment(trip.createdAt).tz(timezone).format("MMM DD, YYYY : HH:mm")
          : "",

        trip.privateNotes || "",
        trip.generalNotes || "",

        trip.serviceArea?.title || "",
        (this.upperCase.transform(trip.levelOfService?.title)) || "",

        fare.breakdown?.waitTimeCharges || "",
        trip.miles || "",
        fare.breakdown?.duration || "",
        fare.breakdown?.distance || "",
        fare.breakdown?.duration || "",
        trip.addons.fare || "",

        trip.preSpecialRate ? Number(trip.preSpecialRate).toFixed(2) : "",
        this.extractFareAmount(fare.cancelBreakdown?.cancelCharges).toFixed(2),
        this.extractFareAmount(fare.cancelBreakdown?.noShowCharges).toFixed(2),
        trip.specialRate ? Number(trip.specialRate).toFixed(2) : "",
        this.extractFareAmount(offeredFare.cancelBreakdown?.cancelCharges).toFixed(2),
        this.extractFareAmount(offeredFare.cancelBreakdown?.noShowCharges).toFixed(2),
      ];

      table.push(data);
    });

    exportToCsv(
      `raw-report-${moment(date[0]).tz(timezone).format("MM-DD-YYYY")}-${moment(date[1])
        .tz(timezone)
        .format("MM-DD-YYYY")}.csv`,
      table
    );
  }

  generateMemberCSV(members: any, fundingSouce:any, spaceType:any, levelOfService:any,appointmentTypes:any,preCompanies:any) {
    const table = [
      [
        "firstName",
        "middleName",
        "lastName",
        "gender",
        "weight",
        "dateOfBirth",
        "contactNumber",
        "phoneNumber",
        "email",
        "prefferedTP",
        "responsibleParty",
        "responsiblePartyPhone",
        "address",
        "city",
        "zipCode",
        "wmrNumber",
        "medicalRecordNumber",
        "privateNotes",
        "generalNotes",
        "timeZone",
        "appointmentType",
        "levelOfService",
        "spaceType",
        "fundingSource",
        "Payment Status"
      ]
    ];

    members.forEach((member: any) => {
      const companies = [];
      for (let item of member.prefferedTP){
        if (item && preCompanies[item]) {
          companies.push(preCompanies[item].name)
        }
      }
     
      const data:any = [
        member.firstName || 'N/A',
        member.middleName || 'N/A',
        member.lastName || 'N/A',
        member.gender || 'N/A',
        member.weight || 'N/A',
        member.dateOfBirth && moment(member.dateOfBirth).format('MM/DD/YYYY') || 'N/A',
        member.contactNumber || 'N/A',
        member.phoneNumber || 'N/A',
        member.email || 'N/A',
        companies || 'N/A',
        member.responsibleParty && member.responsibleParty.name || 'N/A',
        member.responsibleParty && member.responsibleParty.phoneNumber || 'N/A',
        member.address && member.address.name || 'N/A',
        member.address && member.address.city || 'N/A',
        member.address && member.address.zipCode || 'N/A',
        member.wmrNumber || 'N/A',
        member.medicalRecordNumber || 'N/A',
        member.privateNotes || 'N/A',
        member.generalNotes || 'N/A',
        member.timeZone || 'N/A',
        appointmentTypes && appointmentTypes[member.appointmentType] && appointmentTypes[member.appointmentType].title || 'N/A',
        levelOfService && levelOfService[member.levelOfService] && (this.upperCase.transform(levelOfService[member.levelOfService].title)) || 'N/A',
        spaceType && spaceType[member.spaceType] && (this.upperCase.transform(spaceType[member.spaceType].title)) || 'N/A',
        fundingSouce && fundingSouce[member.fundingsource] && fundingSouce[member.fundingsource].title || 'N/A',
        member.squareCustomer ? 'Enabled' : 'Disabled'
      ];

      table.push(data);
    });

    exportToCsv(
      `member-csv.csv`,
      table
    );
  }

  // --Trip Report Download--
  generateTripReport(trips:any, date:any, timezone:any,preServiceAreas?:any,preLevelOfService?:any, preSpacetypes?:any,preFundingSource?:any) {
    const table = [
      [
        "Trip ID",
        "Trip Status",
        "Created At",
        "Service Area",
        "Pick-up Address",
        "Pick-up Date",
        "Drop-Off Address",
        "Drop-Off Date",
        "Actual Miles",
        "Funding Source",
        "LOS",
        "Space Type",
        "Passenger Name",
        "Contact Number",
        "Phone Number",
        "Driver Name",
        "Dispatcher Notes",
        "Private Notes",
        "Payment Status",

        "FS Pre Special Fare",
        "FS Total Fare",
        "FS Cancel Charges",
        "FS No Show Charges",
        "Company Special Fare",
        "Company Total Fare",
        "Company Cancel Charges",
        "Company No Show Charges",
      ]];
    trips.forEach((trip:any) => {
      let acceptedDate, pickupDate, arrivedDate, endDate, finishDate, scheduleTime, appointmentTime, createdAt = ' ';
      if (trip.scheduleTime) {
        scheduleTime = moment(trip.scheduleTime).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.createdAt) {
        createdAt = moment(trip.createdAt).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.appointmentTime) {
        appointmentTime = moment(trip.appointmentTime).tz(timezone).format("MMM DD, YYYY : HH:mm");
      }
      if (trip.job) {
        if (trip.job.trackInfoJob) {
          if (trip.job.trackInfoJob.jobAccepted) {
            if (trip.job.trackInfoJob.jobAccepted.time) {
              acceptedDate = moment(trip.job.trackInfoJob.jobAccepted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobArrived) {
            if (trip.job.trackInfoJob.jobArrived.time) {
              pickupDate = moment(trip.job.trackInfoJob.jobArrived.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobStarted) {
            if (trip.job.trackInfoJob.jobStarted.time) {
              arrivedDate = moment(trip.job.trackInfoJob.jobStarted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }
          if (trip.job.trackInfoJob.jobCompleted) {
            if (trip.job.trackInfoJob.jobCompleted.time) {
              endDate = moment(trip.job.trackInfoJob.jobCompleted.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }

          if (trip.job.trackInfoJob.jobFinished) {
            if (trip.job.trackInfoJob.jobFinished.time) {
              finishDate = moment(trip.job.trackInfoJob.jobFinished.time).tz(timezone).format("MMM DD, YYYY : HH:mm");
            }
          }

        }

      }

      function capitalize(str:any) {
        return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : ' ';
      }

      let serviceAreaTitle = '';
      if (trip.serviceArea && typeof trip.serviceArea === 'object') {
        serviceAreaTitle = this.upperCase.transform(trip.serviceArea.title || ' ');
      } else if (typeof trip.serviceArea === 'string') {
        serviceAreaTitle = preServiceAreas ? this.upperCase.transform(preServiceAreas[trip.serviceArea]?.title || ' ') : ' ';
      }

      let fundingSourceTitle = '';
      if (trip.fundingsource && typeof trip.fundingsource === 'object') {
        fundingSourceTitle = this.upperCase.transform(trip.fundingsource.title || ' ');
      } else if (typeof trip.fundingsource === 'string') {
        fundingSourceTitle = preFundingSource ? this.upperCase.transform(preFundingSource[trip.fundingsource]?.title || ' ') : ' ';
      }

      let levelOfServiceTitle = '';
      if (trip.levelOfService && typeof trip.levelOfService === 'object') {
        levelOfServiceTitle = this.upperCase.transform(trip.levelOfService.title || ' ');
      } else if (typeof trip.levelOfService === 'string') {
        levelOfServiceTitle = preLevelOfService ? this.upperCase.transform(preLevelOfService[trip.levelOfService]?.title || ' ') : ' ';
      }

      let spaceTypeTitle = '';
      if (trip.spaceType && typeof trip.spaceType === 'object') {
        spaceTypeTitle = this.upperCase.transform(trip.spaceType.title || ' ');
      } else if (typeof trip.spaceType === 'string') {
        spaceTypeTitle = preSpacetypes ? this.upperCase.transform(preSpacetypes[trip.spaceType]?.title || ' ') : ' ';
      }

      const fare = trip.fare || {};
      const offeredFare = trip.offeredFare || {};

      let paymentStatus = '';
      if (trip.member?.memberType === 'private_pay') {
      if (trip.flags?.isFullPaid) paymentStatus = 'Paid';
      else if (trip.flags?.isPartiallyPaid) paymentStatus = 'Partially Paid';
      }

      let data = [
        trip.reference && trip.suffix ? trip.reference + '-' +  trip.suffix : ' ',
        capitalize(trip.status),
        createdAt ? createdAt : ' ',
        serviceAreaTitle,
        trip.pickup.address ? trip.pickup.address.name : ' ',
        trip.pickup ? moment(trip.pickup.time).tz(timezone).format("MM/DD/YYYY HH:mm") : ' ',
        trip.destination.address ? trip.destination.address.name : ' ',
        trip.destination ? moment(trip.destination.time).tz(timezone).format("MM/DD/YYYY HH:mm") : ' ',
        trip.miles ? trip.miles : '0',
        fundingSourceTitle,
        levelOfServiceTitle,
        spaceTypeTitle,
        trip ? trip.member?.displayName : ' ',
        trip.member && trip.member.contactNumber ? `\t${trip.member.contactNumber}` : 'N/A',
        trip.pickup && trip.pickup.phoneNumber ? `\t${trip.pickup.phoneNumber}` : 'N/A',
        trip.driver ? trip.driver.displayName : ' ',
        trip.generalNotes ? trip.generalNotes : ' ',
        trip.privateNotes ? trip.privateNotes : ' ',
        paymentStatus,

        trip.preSpecialRate ? Number(trip.preSpecialRate).toFixed(2) : '',
        this.extractTotalFare(fare).toFixed(2),
        this.extractFareAmount(fare.cancelBreakdown?.cancelCharges).toFixed(2),
        this.extractFareAmount(fare.cancelBreakdown?.noShowCharges).toFixed(2),
        trip.specialRate ? Number(trip.specialRate).toFixed(2) : '',
        this.extractTotalFare(offeredFare).toFixed(2),
        this.extractFareAmount(offeredFare.cancelBreakdown?.cancelCharges).toFixed(2),
        this.extractFareAmount(offeredFare.cancelBreakdown?.noShowCharges).toFixed(2),
      ]
      table.push(data)
    });

    exportToCsv(`reports-${moment(date[0]).tz(timezone).format("MM-DD-YYYY")}-${moment(date[1]).tz(timezone).format("MM-DD-YYYY")}.csv`, table);
  }
}



